export default {
  stats: {
    title: "Statistiche",
    tabs: {
      team: "Statistiche squadra",
      player: "Statistiche giocatore",
    },
    empty: {
      unavailable: "Statistiche non disponibili al momento.",
    },
    filters: {
      titles: {
        qualifier: "Qualificatore",
        type: "Tipo",
        position: "Posizione",
      },
      plurals: {
        qualifier: "Qualificatori",
        type: "Tipi",
        position: "Posizioni",
      },
      options: {
        qualifier: {
          averageStats: "Per partita",
          cumulativeStats: "Totale",
        },
        type: {
          offensive: "Offensivo",
          defensive: "Difensivo",
        },
      },
    },
  },
};
